
<button id='leftArrow' (click)='scrollLeft()' class='btn btn-secondary' style='
  height: 46.5rem;
  position: absolute;
  left: 23rem;
  top: 22.5rem;z-index:101'><i class="fas fa-arrow-circle-left"></i></button>
<button id='rightArrow' (click)='scrollRight()' class='btn btn-secondary' style='height: 46.5rem;
position: absolute;
right: -0.6rem;
top: 22rem;z-index:101'><i class="fas fa-arrow-circle-right"></i></button>

    <div id='timelineskipmain' class='timelineRoundsContainer' style='padding-left: 2rem;'>

      <app-skip-resolve-issue [currentPod]='this.currentPod'></app-skip-resolve-issue>
      <app-skip-round-edit-modal [round]='this.currentSkipRound' [assignment]='this.currentJobAssignment'></app-skip-round-edit-modal>
      @if (this.skipRounds.length > 0) {
        @for (item of this.skipRounds; track item; let i = $index) {
          <div class='timelineRound ' >
            <div class="roundHeader" [class.sub]='item.subcontractorId !== -1'>
              <div>
                {{ item.name }} (Count: {{ getCountForSkipRound(item.id) }})<br />
                @if (item.vehicleId !== -1) {
                  <span class="fas fa-fw fa-truck"></span> {{ item.vehicle.registration }}
                  <span class="far fa-fw fa-id-card"></span> {{ item.driver.firstName + ' ' + item.driver.lastName }} ({{ item.driverStartTime }})
                  <br/>
                  @if (getContact(item) !== "" && getContact(item)) {
                    <span class="fas fa-fw fa-phone"></span>
                    } {{getContact(item)}}
                    <br/>
                    @if (item.upcomingInspection !== undefined) {
                      <span class='text-danger'>Inspection Due: {{item.upcomingInspection}}</span>
                    }
                  }
                  @if (item.subcontractorId !== -1 && item.subcontractorId !== 0) {
                    <span class="far fa-fw fa-id-card"></span> {{ item.subcontractor.name }} ({{ item.driverStartTime }})
                  }
                </div>
                <button class='btn btn-primary btn-small' (click)='openEditRoundModal(item)'><i class="fas fa-pencil-alt"></i></button>
              </div>
              <div class="roundContainer" [class.drop]='this.currentHoveringRoundId === item.id' [attr.data-id]='item.id' (dragenter)='this.dragEnter($event, item)' (dragleave)='this.dragLeave($event)' (drop)='this.onOrderDrop($event)' (dragover)='$event.preventDefault();'>
                @for (job of getJobsForSkipRound(item.id) ; track job; let i = $index) {
                  @if (job.jobStatusId !== 3) {
                    <div class='orderContainer droptarget'
                      [class.dragging]='this.draggingId == job.id'
                      [class.drop]='this.currentHoveringJob === i'
                      [attr.data-skipRoundId]='item.id'
                      data-id='{{ i }}'
                      [attr.data-jobId]='job.id'
                      draggable="true"
                      (dragover)="this.blockDragOver($event, i)"
                      (dragstart)="dragStart($event, job)"
                      [class.tipIssue]='this.hasTipIssue(job.id)'
                      [style.background-color]='this.getColourForJobStatus(job)'
                      >
                      @if (job.jobStatusId !== 4 && job.jobStatusId !== 5) {
                        <input type='checkbox' [checked]='this.isCheckBoxSelected(job.id)' (click)='onJobCheckboxClicked($event, job)'/>
                      }
                      <strong>{{ job.order.account.name }}</strong> {{ this.getAddressForOrder(job.order) }}<br />
                      <strong>{{ job.order.skipOrderType.name }}</strong> {{ this.getTypeOfSkip(job.order) }} ({{ job.order.containerSizeType.size }} {{ this.getUnitById(job.order.containerSizeType.unitId).name }}) {{ this.getGrade(job.order) }}
                      <br />
                      @if (this.hasTipIssue(job.id)) {
                        @if (this.getTipDetails(job.id).resolved) {
                          Resolved Issue: {{ this.getTipDetails(job.id).resolution }}
                        }
                        @if (!this.getTipDetails(job.id).resolved) {
                          Job Issue: {{ this.getTipDetails(job.id).issue }}
                          <button class='btn btn-secondary' type='button' (click)='onIssueResolvedClicked(job)'>Issue Resolved</button>
                        }
                      }
                      <!-- <div class='jobStatusName'>Driver Status: {{ this.getDriverStatus(this.getJobById(job.id).driverJobStatusId) }}</div>  -->
                      <ng-container>
                        <!-- Move up /  Move down -->
                        <!--
                        <ng-container *ngIf='job.order.collectionNumber >= 1'>
                          <a id="up" title="Move Up" href="" onclick="this.moveUp().preventDefault;">Move Up</a>/
                        </ng-container>
                        <ng-container *ngIf='job.order.collectionNumber != this.skipRounds.length()'>
                          <a id="down" title="Move Up" href="" onclick="this.moveUp(); return false;">Move Down</a>
                        </ng-container>
                        -->
                        <i class="fas fa-pencil-alt"></i>
                      </ng-container>
                    </div>
                  }
                }
              </div>
            </div>
          }
        }
        @if (this.skipRounds.length === 0) {
          <div class='alert alert-danger'>No skip rounds found. Please create one to start.</div>
        }
      </div>
